import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { BudgetWizardService } from "../services/budget.wizard.service";
import { Budget } from "src/app/model/budget/budget";

@Component({
  selector: "app-budget-observation",
  templateUrl: "./budget-observation.component.html",
  styleUrls: ["./budget-observation.component.css"],
})
export class BudgetObservationComponent implements OnInit {
  form: FormGroup;
  onChange;

  constructor(
    private formBuilder: FormBuilder,
    private service: BudgetWizardService
  ) {
    this.form = this.formBuilder.group({
      Observation: [null],
      BudgetText: [null],
    });
  }

  ngOnInit() {
    this.service.currentBudget$.subscribe((budget: Budget) => {
      if (budget) {
        this.form.patchValue({
          Observation: budget.Observation,
          BudgetText: budget.BudgetText,
        });
      }
    });

    this.form.valueChanges.subscribe((value) => {
      this.service.setObservation(value.Observation, value.BudgetText);
    });
  }
}
